<template>
    <div>
        <div id="checador_div" class="w-100 px-5 py-4">
            <div id="TituloChecador_div">
                <h1 style="margin-bottom: 0px;">Registro del Checador</h1>
                <h3 style="margin-top: 0px;">Calendario para el registro y control de asistencias</h3>
            </div>
            <div class="row d-flex">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low">
                    
                    <div class="area">
                        <div class="row">
                            <div class="col-2">
                                <h6>Numero de Nómina:</h6>
                            </div>
                            <div class="col-10">
                                <h6>{{this.Usuario.NumeroNomina}}</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <h6>Nombre:</h6>
                            </div>
                            <div class="col-10">
                                <h6>{{this.Usuario.NombreCompleto}}</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <h6>Puesto:</h6>
                            </div>
                            <div class="col-10">
                                <h6>{{this.Usuario.Puesto}}</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <h6>Área:</h6>
                            </div>
                            <div class="col-10">
                                <h6>{{this.Usuario.Seccion}}</h6>
                            </div>
                        </div>
                        <div class="row">
                            <hr>
                        </div>
                        <div v-if="eventosFullCalendar!=null">
                            <full-calendar :events="eventosFullCalendar" :config="configuracionFullCalendar"></full-calendar>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import FullCalendar from '@/../static/js/fullcalendar'
import api from '@/../static/js/api'
import axios from 'axios'  
export default {
    components: {
        FullCalendar
    },
    mounted(){   
        this.ObtenerCalendario(0);
    },
    data() {
      return {
            Usuario: {},
            FechaInicial: moment().format('YYYY-MM'),
            FechaDefault: "",
            eventosFullCalendar: [],
            configuracionFullCalendar: {
                defaultDate: this.FechaInicial,
                slotLabelFormat: 'h:mma',
                header: {
                    left: 'prev,today,next',
                    center: 'title',
                    right: 'month,agendaWeek'
                },
                backgroundColor: '#666462',
                defaultView: 'month',
                editable: false,
                eventMouseover: function (data, event, view) {                
                    var tooltip = '<div class="tooltiptopicevent" style="width:auto;height:auto;background:#212529;position:absolute;z-index:10001;padding:10px 10px 10px 10px ;  line-height: 200%;">' + 'Detalle: <br/>' + data.description + '</div>';
                    $("body").append(tooltip);
                    $(this).mouseover(function (e) {
                        $(this).css('z-index', 10000);
                        $('.tooltiptopicevent').fadeIn('500');
                        $('.tooltiptopicevent').fadeTo('10', 1.9);
                    }).mousemove(function (e) {
                        $('.tooltiptopicevent').css('top', e.pageY + 10);
                        $('.tooltiptopicevent').css('left', e.pageX + 20);
                    });
                },
                eventMouseout: function (data, event, view) {
                   if(event.type=="mouseleave")
                    {
                        $(this).css('z-index', 8);
                        $('.tooltiptopicevent').remove();
                    }
                }
            }
      }
    },
    methods:{
        deglosarEtiqueta(){
            var etiqueta =  "No. de Nómina: " + this.persona.NumeroNomina + "<br/>" +
                            "Nombre: " + this.persona.NombreCompleto + "<br/>" +
                            "Puesto: " + this.persona.Puesto + "<br/>" +
                            "Área: " + this.persona.Seccion
            return etiqueta;
        },
        ObtenerCalendario: function(id)
        {
            var peticion = {
                    "PersonaId": id,
                    "FechaInicial" : this.FechaInicial,
                }
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.SIAP.funcion.AsistenciasCalendarioChecador, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => { 
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                        } else { 
                        this.eventosFullCalendar = respuesta.data.Calendario;
                        this.Usuario = respuesta.data.Usuario;
                        comun.SeEstaCargandoInformacion(false);
                        if(this.eventosFullCalendar== null)
                        {
                            comun.mensajeDeAlerta("No existen registros en control de asistencias", null, null);
                        };
                        
                        };
                        
                    }
                    ).catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);                
                    });
        },
    }
}
</script>
<style>
  .padding-div-low {
    padding-top: 40px;
  }

  .fc-view-container {
    background-color: #f6f6f6;
    color: #343a40;
    border-color: #212529 !important;
  }

  .fc-view table {
    border-color: #212529 !important;
  }

  .fc-axis {
    background-color: #504f54;
    color: white;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  }

  .fc-day-header {
    background-color: #212529 !important;
    color: white;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    padding: .75rem !important;
  }

  .fc-button {
    background-color: whitesmoke !important;
    border: none !important;
    padding: .375rem 1.35rem !important;
    color: #212529 !important;
    display: inline-block !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    font-size: 1rem !important;
    border-radius: .25rem !important;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
  }

  .fc-today {
    background-color: #f2f2f2 !important;
    color: #212529 !important;
  }

  .fc-event {
    background-color: #212529;
    border-color: #32383e;
    color: rgb(5, 5, 5) !important;
    padding: .375rem .375rem !important;
    font-size: .75rem !important;
    border-radius: .25rem !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/SIAP/Checador/EventosChecador.vue